module.exports = __webpack_public_path__ + "companies-frontend-b21b3468/Background_01_7x2_a-4414c1319f6a88794a2754bb02544d6e.svg";